import React from 'react'
import classes from './StatusChips.module.css' // create this file

const statusConfig = {
  leave: {
    label: 'On Leave',
    className: classes.statusLeave,
    ellipseColor: '#FDB022',
    value: 'leave',
  },
  partially_paid: {
    label: 'Partially Paid',
    className: classes.statusLeave,
    ellipseColor: '#FDB022',
    value: 'partially_paid',
  },

  // Group 2: same style
  paid: {
    label: 'Paid',
    className: classes.statusPaid,
    ellipseColor: '#38A06C',
    value: 'paid',
  },
  present: {
    label: 'Present',
    className: classes.statusPaid,
    ellipseColor: '#38A06C',
    value: 'present',
  },

  // Group 3: same style
  absent: {
    label: 'Absent',
    className: classes.statusAbsent,
    ellipseColor: '#EF5466',
    value: 'absent',
  },
  unpaid: {
    label: 'Unpaid',
    className: classes.statusAbsent,
    ellipseColor: '#EF5466',
    label: 'unpaid',
  },
  active: {
    label: 'Active',
    className: classes.statusPaid,
    ellipseColor: '#38A06C',
    label: 'active',
  },
  inactive: {
    label: 'Inactive',
    className: classes.statusAbsent,
    ellipseColor: '#EF5466',
    label: 'inactive',
  },
}

const StatusChips = ({ status }) => {
  const normalizedStatus = status?.toLowerCase().trim().replace(/\s+/g, '_')

  const config = statusConfig[normalizedStatus] || {
    label: status || '',
    className: classes.statusUnknown,
  }

  return (
    <div className={`${classes.chip} ${config.className}`}>
      <span
        style={{
          verticalAlign: 'middle',
          marginRight: '6px',
          backgroundColor: config.ellipseColor,
        }}
        className={`${classes.ellipse}`}
      ></span>
      <span>{config.label}</span>
    </div>
  )
}

export default StatusChips
